import { typeDef as CurrencyClient } from './schemas/currencyClientSchema'
import { typeDef as PriceClient } from './schemas/priceClientSchema'

export const typeDefs = [CurrencyClient, PriceClient]
